// extracted by mini-css-extract-plugin
module.exports = {"brandLogo":"BrandLogo_brandLogo__gmMKz","logoImg":"BrandLogo_logoImg__Y57bH"};